import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('SteamOnNews').create(({ theme }) => ({
  root: {
    position: 'relative',
    width: '90%',
    cursor: 'pointer',

    borderRadius: theme.sizes.radiuses.l,
    height: '120px',
    overflow: 'hidden',
    h1: {
      position: 'relative',
      zIndex: '5',
      color: theme.colors.text.primary,
      fontSize: theme.sizes.texts.fontSize.xl,
      fontWeight: '600',
      lineHeight: '40px',
      letterSpacing: '-0.34px',
      margin: '12px 24px',
    },
    background: 'black',
    backgroundImage: 'linear-gradient(90deg, #071925 0%, #114161BF 50%, #1D6EA500 100%)',
  },

  imageContainer: {
    position: 'relative',
    display: 'flex',
    width: 'fit-content',
    flexDirection: 'column',
    gap: '4px',
    top: '20px',
    left: '24px',
    zIndex: 3,
  },

  logo: {
    height: '30px',
    alignSelf: 'center',
  },

  joinGiveaway: {
    position: 'absolute',
    width: '154px',
    height: '27px',
    background: theme.colors.button.primary.background,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    bottom: '0px',
    left: '20px',

    color: theme.colors.text.primary,
    textTransform: 'uppercase',
    fontWeight: 350,
    fontSize: '13px',
    borderTopLeftRadius: '12px',
    borderTopRightRadius: '12px',
  },

  imageContainer2: {
    position: 'relative',
    left: '50%',
    bottom: '70px',
    width: 'fit-content',
  },

  steamDeck: {
    position: 'absolute',
    zIndex: 3,
    width: '143px',
    top: '-16px',
    transform: 'rotate(-15deg)',
  },
  playstationWithPack: {
    position: 'absolute',
    zIndex: 2,
    left: '-40px',
    top: '-40px',
    width: '253px',
  },

  steamCards: {
    position: 'absolute',
    zIndex: 1,
    left: '40px',
    top: '8px',
    width: '133px',
  },
}))
